/* eslint-disable react/style-prop-object */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedNumber, FormattedMessage } from 'react-intl'
import { font, fontFamily } from 'assets/themes/theme-default'

export const SIZE = {
  sm: 'sm'
}

const PricingWrapper = styled.div`
  text-align: center;
  font-size: ${props => (props.size === SIZE.sm ? font.size.xxs : font.size.xs)};
`
// color: ${props => (props.color ? props.color : props.theme.colors.color1.bg)};
const PriceWrapper = styled.div`
  display: block;
  margin: ${props => (props.size === SIZE.sm ? '0px' : '5px 0 0 0')};
  font-size: ${props => (props.size === SIZE.sm ? font.size.lg : font.size.lgsm)};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
`

const PriceFrom = props => {
  const { value, size } = props
  if (!value) return null
  return (
    <PricingWrapper size={size}>
      <FormattedMessage id="layouts-price-from-price-prefix" />
      <PriceWrapper size={size}>
        <FormattedNumber value={value} style="currency" currency="EUR" />
      </PriceWrapper>
    </PricingWrapper>
  )
}

PriceFrom.defaultProps = {
  value: null,
  size: null
}

PriceFrom.propTypes = {
  value: PropTypes.number,
  size: PropTypes.oneOf([SIZE.sm])
}

export default PriceFrom
